/**
 * Maps a subchannel to a transparent brand favicon.
 *
 * Prefers the catalog's `logo_url` when present, otherwise falls back to a
 * bundled transparent SVG in /public/integration_logos. The SVGs have no
 * background, so callers render them on a light chip to stay legible in both
 * light and dark mode. Returns null when there's no logo (caller falls back
 * to initials).
 */

const SUBCHANNEL_LOGO_FILE: Record<string, string> = {
  // Search
  'google-search': 'google-ads',
  'microsoft-ads': 'microsoft-ads',
  'apple-search': 'apple-search',
  'yahoo-ads': 'yahoo-ads',
  'duckduckgo-ads': 'duckduckgo',
  duckduckgo: 'duckduckgo',
  'amazon-search': 'amazon-ads',
  // Social
  meta: 'meta',
  pinterest: 'pinterest',
  linkedin: 'linkedin',
  tiktok: 'tiktok',
  reddit: 'reddit',
  snapchat: 'snapchat',
  'x-twitter': 'x-twitter',
  twitter: 'x-twitter',
  'youtube-shorts': 'youtube',
  nextdoor: 'nextdoor',
  // TV / CTV
  roku: 'roku',
  'nbc-universal': 'nbcu',
  nbcu: 'nbcu',
  peacock: 'peacock',
  hulu: 'hulu',
  paramount: 'paramount',
  'paramount-plus': 'paramount',
  fubo: 'fubo',
  fubotv: 'fubo',
  'disney-plus': 'disney-plus',
  max: 'max',
  'samsung-tv': 'samsung-tv',
  'samsung-tv-plus': 'samsung-tv',
  'lg-channels': 'lg-channels',
  'amazon-prime': 'amazon-prime',
  'amazon-prime-video': 'amazon-prime',
  'pluto-tv': 'pluto-tv',
  tubi: 'tubi',
  sling: 'sling',
  'sling-tv': 'sling',
  vizio: 'vizio',
  'linear-tv': 'linear-tv',
  'linear-broadcast': 'linear-tv',
  // Programmatic
  'the-trade-desk': 'the-trade-desk',
  sonobi: 'atrium',
  dv360: 'dv360',
  magnite: 'magnite',
  xandr: 'xandr',
  criteo: 'criteo',
  'adobe-ads': 'adobe-ads',
  'adobe-advertising': 'adobe-ads',
  'amazon-dsp': 'amazon-ads',
  stackadapt: 'stackadapt',
  basis: 'basis',
  'basis-centro': 'basis',
  mediamath: 'mediamath',
  pubmatic: 'pubmatic',
  // Audio
  spotify: 'spotify',
  'spotify-ads': 'spotify',
  pandora: 'pandora',
  iheartradio: 'iheartradio',
  siriusxm: 'siriusxm',
  audacy: 'audacy',
  // Retail
  'amazon-ads': 'amazon-ads',
  'walmart-connect': 'walmart-connect',
  'target-roundel': 'target-roundel',
  'roundel-target': 'target-roundel',
  'instacart-ads': 'instacart-ads',
  'kroger-precision': 'kroger-precision',
}

/** Transparent favicon URL for a subchannel, or null when none is available. */
export function subchannelFaviconUrl(key: string, logoUrl?: string | null): string | null {
  if (logoUrl && logoUrl.trim()) return logoUrl
  const file = SUBCHANNEL_LOGO_FILE[key]
  return file ? `/integration_logos/${file}.svg` : null
}
